import styled, { css } from "styled-components";

const PaymentMethodCardBase = styled.div`
  ${({ theme, onClick }) => css`
    transition: ${theme.transition.quickest};
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 0 0 auto;
    position: relative;
    padding: 1.4rem 2rem;
    width: 20.8rem;
    min-height: 14.2rem;
    border: 0.1rem dashed ${theme.fonts.colors.secondary};
    border-radius: 1rem;
    cursor: ${!onClick ? "default" : "pointer"};

    @media (min-width: 768px) {
      width: 24.4rem;
    }

    &.inline {
      padding: 0.6rem 2rem;
      width: 100%;
      min-height: auto;
    }
  `};
`;

export default PaymentMethodCardBase;
